<template>
    <pm-gallery-layout>
        <div
            style="padding-top: 26px; padding-bottom: 20px; flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
            <div id="gallery_list_before_after">

                <div v-for="(item, idx) in items.slice(0,maxItems)" :key="item.id" @click.stop="openViewer(idx)" style="margin: 0 24px 32px 24px;">
                    <div
                        :id="'pm-gallery-media-grid-thumb-' + item.id"
                        :data-src="item.src"
                        :data-id="item.id"
                        class="editable pm-gallery-media-before-after"
                        :data-idx="idx+1"
                        :class="(idx+1)%10 === 0 ? 'pm-infinite-scroll-observable' : ''"
                    >
                        <div class="pm-gallery-media-before"
                             :style="'background-image: url(\'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_guetzli.jpg') + '\')'">
                        </div>
                        <div class="pm-gallery-media-after"
                             :style="'background-image: url(\'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_guetzli.jpg') + '\')'">
                        </div>

                        <!--mdi v-once
                            style="filter: drop-shadow(rgba(0, 0, 0, 0.3) 1px 1px 0px); border-radius: 4px; padding: 7px 7px 5px 5px; x-background: #ddd; opacity: 1; color: #fff; right: 5px; top: 5px; position: absolute;"
                            :size="28">arrow-expand
                        </mdi-->

                    </div>
                    <span style="color: #555; font-size: 13px;"><b style="font-weight: 600;">Case #{{ idx + 1 }}</b> - {{
                            item.title.en
                        }}</span>
                </div>
            </div>
        </div>
        <pm-photo-swipe ref="photoSwipe" @toggleFavved="reload" />
    </pm-gallery-layout>
</template>

<style>
.pm-gallery-media-before-after {
    height: Calc(100vw * 0.29);
    position: relative;
    display: flex;
    overflow: hidden;
    padding: 10px;
    background: #ddd;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .15);
    margin-bottom: 5px;
}

.pm-gallery-media-before {
    margin-right: 5px;
    width: 50%;
    height: 100%;
    background-size: cover;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .25);
}

.pm-gallery-media-after {
    margin-left: 5px;
    width: 50%;
    height: 100%;
    background-size: cover;
    background-position: right bottom;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .25);
}
</style>

<script>
import MediaList from "../../configs/gallery/media";
import PmPhotoSwipe from "./photoswipe";
import PmGalleryRouteBase from "./gallery_route_base";

export default {
    extends: PmGalleryRouteBase,
    name: "PmModGalleryBeforeAfter",
    components: {
        PmPhotoSwipe,
    },
    data: () => ({
        items: [],
        groupByGalleries: false,
        galleryTitleMap: null,
        galleryChildMap: null,
        maxItems: 20,
    }),

    created() {
        this.t0 = performance.now()
        this.items = this.getItems();
    },

    mounted() {
        var t1 = performance.now()
        // alert("Call to doSomething took " + (t1 - this.t0) + " milliseconds.")
        this.initInfiniteScroll();
    },

    activated() {
        // this.items = this.getItems();
        this.maxItems = 20;
        this.initInfiniteScroll();
    },

    beforeDestroy() {
        this.observer.disconnect();
    },

    methods: {
        initInfiniteScroll() {
            this.observer = new IntersectionObserver(entry => {
                if (entry[0].isIntersecting) {
                    this.observer.unobserve(entry[0].target);
                    let idx = entry[0].target.dataset.idx;
                    if(this.items.length <= this.maxItems) return;
                    if (this.maxItems < idx + 20) {
                        this.maxItems = parseInt(idx) + 20;
                        this.$nextTick(()=>{
                            const observableEls = document.querySelectorAll(".pm-infinite-scroll-observable");
                            if (observableEls) {
                                this.observer.observe(observableEls[observableEls.length - 1]);
                            }
                        });
                    }
                }
            });

            const observableEls = document.querySelectorAll(".pm-infinite-scroll-observable");

            if (observableEls) {
                observableEls.forEach(el => {
                    this.observer.observe(el);
                });
            }


          // pm-infinite-scroll-observable

        },
        openViewer(idx) {
            this.$refs['photoSwipe'].init({
                start: idx,
                items: this.items,
                galleryId: 0,
                galleryTitle: "Before-after",
                categoryTitle: "Before-after"
            });
        },
        reload() {
            this.items = this.getItems();
        },
        getItems() {
            // const t0 = performance.now()

            const imgMap = new Map();
            const items = MediaList.filter((item) => {
                if (!item.tags[0].toLowerCase().includes('before-after')) return false;
                if (imgMap.has(item.src)) return false;
                imgMap.set(item.src, 1);
                return (item.width === 626 && item.height === 800);
            });
            // const t1 = performance.now()
            // alert("Call to getItems took " + (t1 - t0) + " milliseconds.")
            this.initInfiniteScroll();

            const galleryIds = [104,78,103,111,89,17,112,75,47,4,1,10,13,15,24,26,79,34,35,36,50,51,54,64,42,-1];

            /*items.forEach(item => {
                Object.freeze(item);
            })*/

            return items;
        },
        toggleGrid() {
            this.grid--;
            if (this.grid === 0) this.grid = 3;
            localStorage.setItem('galleryGrid', this.grid);
        },
    },
    toolbar() {
        const items = [];

        items.push({
            mdi: "image-outline",
            text: "Photos",
            callback: () => {
                this.$router.push('/gallery');
            },
        });

         items.push({
             mdi: "emoticon-happy-outline",
             text: "Before-after",
             active: true,
            callback: () => {
                this.$router.push('/gallery-before-after').catch(_ => {});
            },
        });

        items.push({
            mdi: "heart-outline",
            text: "Favourites",
            callback: () => {
                this.$router.push('/gallery-favourites');
            },
        });

        items.push({
            back: true,
            callback: () => {
                if (window.prevGalleryId > 0) this.$router.push('/gallery/'+window.prevGalleryId);
                else this.$router.push('/gallery');
            },
        });

        return ([items]);
    },
};

</script>
